export {
  default,
  advanceModalActions,
  advanceModalSlice,
} from "./advanceModalSlice";

export enum AdvanceMODAL {
  TANFEETIFORM = "TANFEETIFORM",

}

export type AdvanceModalType = "" | keyof typeof AdvanceMODAL;

export interface OpenModalState {
  data: any;
  width: any;
  type: AdvanceModalType;
  loading?: boolean;
}

export type AdvanceModalState = OpenModalState & {
  open: boolean;
};
